import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';


// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// 

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HotToastService } from '@ngneat/hot-toast';

// Jquery?
import * as $ from "jquery"
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { AllRecipients } from 'src/app/shared/models/allRecipients.model';
import { SubjectServiceResolutionOutcomeType } from 'src/app/shared/models/subject-service-resolution-outcome-type.model';
// import { TestingCompiler } from '@angular/core/testing/src/test_compiler';

import { BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import { BsDatepickerModule, DatePickerComponent } from 'ngx-bootstrap/datepicker';
import { SubjectServiceResolutionOutcomeTypeModalComponent } from '../subject-service-resolution-outcome-type-modal/subject-service-resolution-outcome-type-modal.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { sortResolutionOutcomes, sortResolutionOutcomeTypes } from 'src/app/shared/functions/subject-service-resolution-outcome-display';


@Component({
  selector: 'app-subject-service-resolution-outcomes',
  templateUrl: './subject-service-resolution-outcomes.component.html',
  styleUrls: ['./subject-service-resolution-outcomes.component.scss']
})
export class SubjectServiceResolutionOutcomesComponent implements OnInit {



   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;
  @Input() selectedResolutionIds: any[] = [];



  subject_com_types: any;
  subject_com_type_id: any;
  subject_template_docs: Object;


  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };


  system_automation: Object;
  system_automations: any;


  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

   // Function below pushes form to allRecipients array, and closes window.
   @Output('addRecipientFromModal') addRecipientFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addAutomationFromModal') addAutomationFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addResolutionFromModal') addResolutionFromModal: EventEmitter<any> = new EventEmitter();
   @Output('removeResolutionFromModal') removeResolutionFromModal: EventEmitter<any> = new EventEmitter();


   model: AllRecipients;
   
   public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  system_log_type_automations: Object;
  system_log_type_automation_triggers: Object;
  get_latest_system_automation_id: Object;
  resolution_outcomes: any[] = [];
  resolution_outcomes_by_type: any[] = [];

  
  // resolution_outcome_types: SubjectServiceResolutionOutcomeType[] = [];
  resolution_outcome_types: any;
  selectedTypeId?: any;
  typeSelected: any;

  // @Output('typeSelected') typeSelected = new EventEmitter<number>();
 

  modalAction = '';
  modalSelectedId?: number;
  count: any;
  initialCount: any;

  modalRef?: BsModalRef;



  constructor(
    private http: HttpClient, private router: Router, private _demoService: DemoService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    public toastr: HotToastService,
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,
     public bsModalRef: BsModalRef,
      private fb: FormBuilder,
  ) {
    // this.subject_com_type_id = +this.route.snapshot.paramMap.get('subject_com_type_id');
   }

  ngOnInit() {

    // this.getSubjectComType(this.subject_com_type_id);
    // this.getSubjectTemplateDocsGrid(this.subject_com_type_id);

    // this.getSystemAutomationsGrid();


    // New May26 Types
    this.getSubjectServiceResolutionOutcomeTypes()
    this.getSubjectServiceResolutionOutcomes();

    // syncfusion GRID OPTIONS
    this.toolbarOptions = ['Search'];
    this.initialPage = { pageSize: 5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};

   this.wrapSettings = { wrapMode: 'Content' };
  // end grid options

  }


  private getSubjectComType(subject_com_type_id) {
    this._demoService.getSubjectComType(subject_com_type_id)
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }


  private getSystemAutomation(system_automation_id) {
    this._demoService.getSystemAutomation(system_automation_id)
      .subscribe(
        res => this.system_automation = res,
        err => console.error(err.status)
      );
  }


  private getSystemAutomationsGrid() {
    this._demoService.getSystemAutomationsGrid()
      .subscribe(
        res => this.system_automations = res,
        err => console.error(err.status)
      );
  }


  
  private getSubjectServiceResolutionOutcomes() {
    this._demoService.getSubjectServiceResolutionOutcomes()
      .subscribe(
        (res: any) => {
          this.resolution_outcomes = sortResolutionOutcomes(res || []);
          this.refreshResolutionOutcomeGroups();
        },
        err => console.error(err.status)
      );
  }



  getSubjectServiceResolutionOutcomeTypes() {
    this._demoService.getSubjectServiceResolutionOutcomeTypes().subscribe(
      (res: any) => {
        this.resolution_outcome_types = sortResolutionOutcomeTypes(res || []);
        if (!this.selectedTypeId && this.resolution_outcome_types && this.resolution_outcome_types.length) {
          this.selectedTypeId = Number(this.resolution_outcome_types[0].subject_service_resolution_outcome_type_id);
        }
        this.refreshResolutionOutcomeGroups();
      },
      err => console.error(err.status)
    );
  }


  private getSubjectTemplateDocsGrid(subject_com_type_id) {
    this._demoService.getSubjectTemplateDocsGrid(subject_com_type_id)
      .subscribe(
        res => this.subject_template_docs = res,
        err => console.error(err.status)
      );
  }


 // Grid Functions
 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.getSubjectTemplateDocsGrid(this.subject_com_type_id);
  this.grid.refresh();
};


gridItemView(id) {
  this.router.navigate(['/admin/communication/com_type_template_doc_view/' + id + '']);
}

gridItemEdit(id) {
  this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + id + '']);
}



deleteSubjectTemplateDoc(doc_id) {
  if (confirm('Are you sure you want to delete this communication template. It cannot be undone!? ')) {
  this._demoService.deleteSubjectTemplateDoc(doc_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    this.toastr.success('Subject Communication template Removed. We have left all docx and themes original files on the server');
    //  this.getSubjectAgentAssigned(subject_id);
    this.gfunc.globalSystemSubjectTemplateDocsSkipRoute(this.subject_com_type_id);
      //  return true;
     },
     error => {
       console.error('Error removing communication template!');
       return error(error.error);
     }
  );
  
  }
  
  
// end grid functions

} // end if



getSystemAutomationsArray(request_array) {
  this._demoService.getSystemAutomationsArray(request_array).subscribe(
     data => { this.system_log_type_automations = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


// /api/system/automations/log/Types/listbyarray

// let new_model = {
//   system_automation_array: this.allAutomations
// }
// this.getSystemAutomationsArray(new_model);


// getSystemAutomationLogTypeTriggersByArray(request_array) {
//   this._demoService.getSystemAutomationLogTypeTriggersByArray(request_array).subscribe(
//      data => { this.system_log_type_automation_triggers = data;
//       let res = data[0];

//       // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
//       // // console.log(this.arrCase);
//       // this.Items = data['Items'] ;
//       // this.sent_data = this.Items;
//       // this.sent_data = this.myob_account_codes;

//     },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  }




deleteSystemAutomation(system_automation_id) {
  if (confirm('Are you sure you want to delete this System Automation. It cannot be undone!? ')) {
  this._demoService.deleteSystemAutomation(system_automation_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    this.toastr.success('System Automation Removed and Deleted');
    //  this.getSubjectAgentAssigned(subject_id);
    this.gfunc.globalSystemAutomationsSkipRoute();
      //  return true;
     },
     error => {
       console.error('Error removing System Automation!');
       return error(error.error);
     }
  );
  
  }
  
  
// end grid functions

} // end if



makeDuplicateAutomation(model){
  if (confirm('We are about duplicate this System Automation, Are you Sure?')) {
  // post a new With this model. & Name as copuy
  model.system_automation_name =  model.system_automation_name + '_COPY'
  model.system_automation_description = '_COPY **** of **** ' + model.system_automation_description
  model.doc_notes = '_COPY **** of **** ' + model.doc_notes
  model.is_active = '';
  model.templates_created_tested = '';
  this.createSystemAutomation(model);
  }
}



createSystemAutomation(model) {
  this._demoService.createSystemAutomation(model).subscribe(
       data => {  this.get_latest_system_automation_id = data; // this is the retuned json upon creation.
        this.toastr.success('New System Automation Added.');
      this.gfunc.globalSystemAutomationsSkipRoute();
        return true;
       },
       error => {
         this.toastr.error('Adding Automation Failed :: Please try again!');
         // console.log(Observable.throw(error));
         // return Observable.throw(error);
       }
  );
  }






getSubjectServiceResolutionOutcomesByType(typeId: number) {
  this._demoService.getSubjectServiceResolutionOutcomesByType(typeId)
    .subscribe(
      (res: any) => this.resolution_outcomes = sortResolutionOutcomes(res || []),
      err => console.error(err.status)
    );
}



  onTypeSelected(typeId: number) {
    this.selectedTypeId = Number(typeId);
  }

  // Temporary release restriction point: relax this when non-admin/user rules are ready.
  canViewLegacyAutomationDebugGrid(): boolean {
    return false;
  }

  isActive(value: any): boolean {
    return value == null || value === '' || value === 1 || value === '1' || value === true || value === 'Y' || value === 'y';
  }

  refreshResolutionOutcomeGroups(): void {
    const groups = [];
    const activeTypes = Object(this.resolution_outcome_types || []).filter((type: any) => this.isActive(type.is_active != null ? type.is_active : type.subject_service_resolution_outcome_type_is_active));

    activeTypes.forEach((type: any) => {
      const typeId = Number(type.subject_service_resolution_outcome_type_id);
      const outcomes = Object(this.resolution_outcomes || []).filter((outcome: any) => {
        return Number(outcome.subject_service_resolution_outcome_type_id) === typeId && this.isActive(outcome.is_active);
      });

      groups.push({
        type_id: typeId,
        type_name: type.subject_service_resolution_outcome_type_name,
        type_description: type.subject_service_resolution_outcome_type_description,
        outcomes
      });
    });

    this.resolution_outcomes_by_type = groups;
  }

  isResolutionSelected(id: any): boolean {
    const numericId = Number(id);
    return Object(this.selectedResolutionIds || []).some((selectedId: any) => Number(selectedId) === numericId);
  }

  addResolution(id: any): void {
    this.addResolutionFromModal.emit(Number(id));
  }

  removeResolution(id: any): void {
    this.removeResolutionFromModal.emit(Number(id));
  }



  //   openModal(actionType: string, id?: number): void {
  //   if (actionType === 'edit' && !id) return; // Prevent edit without an ID
  //   this.modalAction = actionType;
  //   this.modalSelectedId = id;
  // }


 openModal(actionType: string, id?: number): void {
    if (actionType === 'edit' && !id) return; // Prevent edit without an ID
    const initialState = {
      actionType,
      selectedId: id
    };
    this.modalRef = this.modalService.show(SubjectServiceResolutionOutcomeTypeModalComponent, { initialState });

    this.modalRef.content.closeEvent.subscribe((result) => {
      if (result === 'refresh') {
        this.getSubjectServiceResolutionOutcomeTypes();
      }
    });
  }

  

   refreshData(): void {
    this.getSubjectServiceResolutionOutcomeTypes();
  }


  sendTypeID(id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count = id;
  this.initialCount = id;
// console.log('sending ID:' + this.count);

}

}
